var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnter42 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 42,
  height: 42,
  viewBox: "0 0 42 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.5 8H16.5V9H32.5C33.163 9 33.7989 9.26339 34.2678 9.73223C34.7366 10.2011 35 10.837 35 11.5V24.5C35 25.163 34.7366 25.7989 34.2678 26.2678C33.7989 26.7366 33.163 27 32.5 27H8.70726L16.2072 19.5001L15.5001 18.793L6.79297 27.5001L15.5001 36.2072L16.2072 35.5001L8.70711 28H32.5C33.4283 28 34.3185 27.6313 34.9749 26.9749C35.6313 26.3185 36 25.4283 36 24.5V11.5C36 10.5717 35.6313 9.6815 34.9749 9.02513C34.3185 8.36875 33.4283 8 32.5 8Z",
  fill: "currentColor"
})));
export default SvgEnter42;